module.exports = __webpack_public_path__ + "img/diningroom.cd9b5ffd.svg";